import { ENVIRONMENT } from '~/constants';

const isLocalhost = window?.CONFIG?.environment === ENVIRONMENT.LOCAL;

export default () => isLocalhost;
